"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDebugSettings = setDebugSettings;
function setDebugSettings(includeServerLog, showHiddenProperties, showHiddenResults) {
    return {
        type: "SetDebugSettings",
        includeServerLog,
        showHiddenProperties,
        showHiddenResults
    };
}
//# sourceMappingURL=actions.js.map